import { Component } from "react"

/* Components */
import Icon from "../../components/Icon"


/* The mounted widget — the helper below talks to it */
let widget = null


/* Widget Confirm — the question asked before an action which is hard to take back. It is drawn
   by hand and not by a library, so it always stands above the windows of the panel: the card of
   a point, a form inside it and the poster all live lower */
class Confirm extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            leaving: false,
            options: {}
        }

        /* The answer of the question is given back to the one who asked it */
        this.resolve = null
    }

    componentDidMount = () => {

        /* The helper asks the questions here */
        widget = this

        document.addEventListener("keydown", this.keydown)
    }

    componentWillUnmount = () => {

        document.removeEventListener("keydown", this.keydown)

        clearTimeout(this.timer)
        widget = null
    }

    /* The escape key answers no */
    keydown = event => {

        if (event.key === "Escape" && this.state.visible) {
            this.answer(false)
        }
    }

    /* Ask the question */
    ask = options => {

        return new Promise(resolve => {

            this.resolve = resolve
            this.setState({ visible: true, leaving: false, options: options ? options : {} })
        })
    }

    /* Answer it */
    answer = value => {

        /* Fields */
        const { visible, leaving } = this.state

        /* Already answered */
        if (!visible || leaving) {
            return
        }

        this.setState({ leaving: true })

        /* The one who asked gets the answer at once, the window closes after its animation */
        if (this.resolve) {
            this.resolve(value)
            this.resolve = null
        }

        this.timer = setTimeout(() => this.setState({ visible: false, leaving: false }), 180)
    }

    render = () => {

        /* Fields */
        const { visible, leaving, options } = this.state

        /* Check Data */
        if (!visible) {
            return null
        }

        const danger = !!options.danger

        return (
            <div onClick={() => this.answer(false)} className={`confirm-overlay ${leaving ? "leaving" : ""}`}>

                <div onClick={event => event.stopPropagation()} className={`confirm ${leaving ? "leaving" : ""}`}>

                    <div className={`confirm-icon ${danger ? "danger" : ""}`}>
                        <Icon name={danger ? "trash" : "question"} size={24} width={1.8} />
                    </div>

                    <div className="confirm-title">{options.title ? options.title : "Вы уверены?"}</div>

                    {options.text && <div className="confirm-text">{options.text}</div>}

                    <div className="confirm-buttons">

                        <div onClick={() => this.answer(false)} className="confirm-button light">
                            {options.cancelText ? options.cancelText : "Отмена"}
                        </div>

                        <div onClick={() => this.answer(true)} className={`confirm-button ${danger ? "danger" : ""}`}>
                            {options.confirmText ? options.confirmText : "Продолжить"}
                        </div>

                    </div>

                </div>

            </div>
        )
    }
}


/* Ask before an action which is hard to take back — the answer comes as a promise */
export const confirm = options => {

    /* The widget is not mounted — nothing was asked, so nothing was allowed */
    if (!widget) {
        return Promise.resolve(false)
    }

    return widget.ask(options)
}


export default Confirm
